import Layout from '../../layout'
import TabelPeserta from './components/Tabel'
import { useEffect, useState } from 'react'

// REDUX
import { useDispatch, useSelector } from 'react-redux'
import { selectCurrentUser } from '../../redux/user/user.selectors'
import { removeCurrentUser } from '../../redux/user/user.action'

import FetchLoading from '../../components/FetchLoading'
import ButtonLink from '../../components/ButtonLink'
import axios from 'axios'
import { Button, DatePicker, message, Modal } from 'antd'
import { useNavigate } from 'react-router-dom'
import { ROLE_PESERTA_READ_ONLY } from '../../utils'
import styles from './Peserta.module.css'
import { SearchData } from '../../components'

// canst XLSX = require('xlsx')
const fileDownload = require('js-file-download')

const Peserta = () => {
  const currentUser = useSelector(selectCurrentUser)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [peserta, setPeserta] = useState(null)
  const [searchField, setSearchField] = useState('')
  const [modalOpen, setModalOpen] = useState(false)
  const [mount, setMount] = useState('')
  const [year, setYear] = useState('')

  const user_read_only = ROLE_PESERTA_READ_ONLY.find(
    (role) => role === currentUser.user.role
  )

  useEffect(() => {
    axios({
      method: 'get',
      url: '/peserta',
      headers: {
        Authorization: `Bearer ${currentUser.token}`,
      },
    })
      .then(({ data }) => {
        setPeserta(data)
      })
      .catch((error) => {
        if (error.response.status === 404) {
          message.error('404 Not Found')
        }
        if (error.response.status === 401) {
          message.error('401 Unauthorized')
          dispatch(removeCurrentUser())
          navigate('/login')
        }
        if (error.response.status === 500) {
          message.error('500 Internal Server Error')
        }
        if (error.response.status === 403) {
          message.error('403 Forbidden')
        }
      })
  }, [currentUser.token, dispatch, navigate])

  // const CSVToArray = (strData, strDelimiter) => {
  //   strDelimiter = strDelimiter || ','

  //   var objPattern = new RegExp(
  //     '(\\' +
  //       strDelimiter +
  //       '|\\r?\\n|\\r|^)' +
  //       '(?:"([^"]*(?:""[^"]*)*)"|' +
  //       '([^"\\' +
  //       strDelimiter +
  //       '\\r\\n]*))',
  //     'gi'
  //   )

  //   var arrData = [[]]

  //   var arrMatches = null

  //   while ((arrMatches = objPattern.exec(strData))) {
  //     var strMatchedDelimiter = arrMatches[1]
  //     if (strMatchedDelimiter.length && strMatchedDelimiter !== strDelimiter) {
  //       arrData.push([])
  //     }

  //     var strMatchedValue
  //     if (arrMatches[2]) {
  //       strMatchedValue = arrMatches[2].replace(new RegExp('""', 'g'), '"')
  //     } else {
  //       strMatchedValue = arrMatches[3]
  //     }
  //     arrData[arrData.length - 1].push(strMatchedValue)
  //   }

  //   return arrData
  // }

  const handleFilterSearch = (datas) => {
    return datas.filter((data) =>
      data.name.toLowerCase().includes(searchField.toLowerCase())
    )
  }
  const handleFilteringProgram = () => {
    let pesertaFilter = peserta
    if (searchField.length) {
      pesertaFilter = handleFilterSearch(pesertaFilter)
    }
    return pesertaFilter
  }

  const pesertaFilter = peserta !== null ? handleFilteringProgram() : peserta

  const handleFilterSearchOption = () => {
    let searchOption = peserta
    searchOption = searchOption.map((peserta) => {
      return { value: peserta.name, label: peserta.name }
    })
    return searchOption
  }

  const searchOptionFilter = peserta ? handleFilterSearchOption() : null

  return (
    <Layout id="peserta" title="Peserta">
      <FetchLoading data={peserta}>
        {user_read_only ? null : (
          <ButtonLink
            urlRoute="/peserta/peserta-tambah"
            title="Tambah Perserta"
          />
        )}
        <div className={styles.filterGroup}>
          <SearchData
            setSearchField={setSearchField}
            optionSearchField={searchOptionFilter}
          />
          <Button onClick={() => setModalOpen(true)}>Export Data</Button>
        </div>
        <TabelPeserta
          peserta={pesertaFilter}
          user_read_only={user_read_only}></TabelPeserta>
      </FetchLoading>
      <Modal
        title="Export Data Peserta"
        centered
        footer={false}
        visible={modalOpen}
        onCancel={() => setModalOpen(false)}>
        <DatePicker
          onChange={(dateString) => {
            setMount(dateString.format('M'))
            setYear(dateString.format('YYYY'))
          }}
          picker="month"
          size="large"
          style={{ width: '100%' }}
        />
        <div className={styles.buttonExport}>
          <Button
            style={{ width: '100%' }}
            onClick={() =>
              axios({
                method: 'get',
                url: `/peserta/download?month=${mount}&year=${year}`,
                headers: {
                  Authorization: `Bearer ${currentUser.token}`,
                },
              })
                .then((response) => {
                  // let wb = XLSX.utils.book_new()
                  // let ws = XLSX.utils.json_to_sheet(
                  //   CSVToArray(response.data, ',')
                  // )

                  // XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')

                  // XLSX.writeFile(wb, 'Data Peserta.xlsx')
                  fileDownload(response.data, `peserta-${mount}-${year}.csv`)
                })
                .catch((error) => {
                  console.log(error)
                })
            }>
            Export
          </Button>
        </div>
      </Modal>
    </Layout>
  )
}

export default Peserta
